export default __webpack_public_path__ + "static/media/廖世偉.55a567f6.jpg";